import React, { useEffect, useRef, useState } from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import { motion, useAnimation } from 'framer-motion';
import * as styles from './index.module.scss';
import AnimationButton from '../../../components/animationButton';
import useIsMobile from '../../../hooks/useIsMobile';

const Index = () => {
  const isMobile = useIsMobile();
  const [count, setCount] = useState(0);
  const targetNumber = 100000;
  const duration = 2000; // 2 seconds
  const ref = useRef(null);
  const formatNumber = (number: number) => {
    return new Intl.NumberFormat().format(number);
  };
  const controls = useAnimation();
  const handleViewportEnter = () => {
    controls.start({
      rotate: 360,
      scale: 1,
      x: 'calc(-18%)',
      y: 'calc(-60%)',
    });
  };
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const startTime = performance.now();

          const animate = (currentTime) => {
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / duration, 1);
            const newCount = Math.floor(progress * targetNumber);
            setCount(newCount);

            if (progress < 1) {
              requestAnimationFrame(animate);
            }
          };

          requestAnimationFrame(animate);
          observer.unobserve(ref?.current); // 动画完成后停止观察
        }
      });
    });

    observer.observe(ref?.current);

    return () => {
      observer.disconnect(); // 清理观察者
    };
  }, []);

  return (
    <div className={styles.governance} ref={ref}>
      <section className={styles.top}>
        {isMobile ? (
          <div className={styles.title}>
            Encouraging{' '}
            <span>
              builders
              <br /> to apply for grants
            </span>
            <br />
            to boost community engagement.
          </div>
        ) : (
          <div className={styles.title}>
            Encouraging{' '}
            <span>
              builders
              <br /> to apply for grants
            </span>{' '}
            to
            <br /> boost community engagement.
          </div>
        )}
        <div className={styles.rightContent}>
          {/* coin占位 */}
          <div className={styles.placeHolderDiv} />
          {/* 中间数字 */}
          <div className={styles.numbers}>
            <div className={styles.label}>First Phase Total Cap</div>
            <div className={styles.topNumber}>10,000,000 MTT</div>
            <div className={styles.hr}>
              {/* <div className={styles.apy}>
                <div>APY</div>
                <div>30.12%</div>
              </div> */}
            </div>
            <div className={styles.label}>Minimum Amount</div>
            <motion.div className={styles.bottomNumber}>
              {formatNumber(count)} MTT
            </motion.div>
          </div>
          {/* 右侧数字 */}
        </div>
      </section>

      <section className={styles.bottom}>
        <div className={styles.bottomTitle}>
          Guiding Principles{!isMobile && <span>Coming soon</span>}
        </div>
        <div className={styles.bottomContent}>
          <div className={styles.item}>
            <img
              src="http://266-crawler.oss-ap-southeast-1.aliyuncs.com/static/Frame%201410078470.png"
              alt=""
            />
            <div className={styles.content}>
              <label>Innovative Impact</label>
              <span>
                Focus on unique enhancements to MTT Network, from infrastructure
                to user engagement.
              </span>
            </div>
          </div>
          <div className={styles.item}>
            <img
              src="http://266-crawler.oss-ap-southeast-1.aliyuncs.com/static/Frame%201410078469.png"
              alt=""
            />
            <div className={styles.content}>
              <label>Ecosystem Alignment</label>
              <span>
                Align with MTT’s goals for scalable, accessible, and interactive
                gaming on blockchain.
              </span>
            </div>
          </div>
          <div className={styles.item}>
            <img
              src="http://266-crawler.oss-ap-southeast-1.aliyuncs.com/static/Frame%201410077823.png"
              alt=""
            />
            <div className={styles.content}>
              <label>Technical Feasibility</label>
              <span>
                Present a realistic technical plan, showing the skills required
                for implementation.
              </span>
            </div>
          </div>
          <div className={styles.item}>
            <img
              src="http://266-crawler.oss-ap-southeast-1.aliyuncs.com/static/Frame%201410078471.png"
              alt=""
            />
            <div className={styles.content}>
              <label>Sustainability</label>
              <span>
                Provide a roadmap showing how the project’s benefits will extend
                beyond the grant’s initial phase.
              </span>
            </div>
          </div>
        </div>
        {isMobile && <div className={styles.bottomComing}>Coming soon</div>}
      </section>
      <motion.img
        initial={{ scale: 0 }}
        animate={controls}
        transition={{
          type: 'spring',
          stiffness: 260,
          damping: 20,
        }}
        onViewportEnter={handleViewportEnter}
        className={styles.coin}
        src="https://cdn-web.mtt.xyz/static/Rectangle.png"
        alt=""
      />
    </div>
  );
};

export default Index;
